import React, { MouseEventHandler } from 'react';
import {
  Modal, Button, Col, Row, Typography, Spin,
} from 'antd';

const { Title } = Typography;

interface ConfirmDeleteModalProptype {
  isModalOpen: boolean,
  handleCancel: MouseEventHandler<HTMLElement>,
  handleDelete: MouseEventHandler<HTMLElement>,
  isLoading: boolean,
  title: string,
  deleteButtonText: string,
  warningMessage?: string,
  affectedSuites?: string[],
  isImpactLoading?: boolean,
}

const DeleteConfirmationModal = ({
  isModalOpen,
  handleCancel,
  handleDelete,
  isLoading,
  title,
  deleteButtonText,
  warningMessage,
  affectedSuites = [],
  isImpactLoading = false,
}: ConfirmDeleteModalProptype) => {
  const shouldShowImpact =
    Boolean(warningMessage) || isImpactLoading || affectedSuites.length > 0;

  return (
  <Modal
    className="delete-confirm-modal"
    open={isModalOpen}
    centered
    width={448}
    onCancel={handleCancel}
    closable={false}
    maskClosable={!isLoading}
    keyboard={!isLoading}
    footer={null}
  >
    <Row>
      <Col span={24}>
        <Row>
          <Col>
            <Title level={5}>{title}</Title>
            <p className="delete-content">Please note this action is irreversible.</p>
            {shouldShowImpact && (
              <>
                {warningMessage && (
                  <p className="delete-content">{warningMessage}</p>
                )}
                {isImpactLoading ? (
                  <div className="delete-content impact-loading">
                    <Spin size="small" />
                    <span>Checking impacted test execution suites</span>
                  </div>
                ) : (
                  <>
                    <p className="delete-content">
                      Affected test execution suites: {affectedSuites.length}
                    </p>
                    {affectedSuites.length > 0 && (
                      <ul className="delete-content">
                        {affectedSuites.map((suiteName) => (
                          <li key={suiteName}>{suiteName}</li>
                        ))}
                      </ul>
                    )}
                  </>
                )}
              </>
            )}
          </Col>
        </Row>
        <Row className="btn-main">
          <Col span={4}>
            <Button className="edit-btn" shape="round" onClick={handleCancel} disabled={isLoading}>
              Cancel
            </Button>
          </Col>
          <Col span={4}>
            <Button
              className="delete-btn"
              shape="round"
              onClick={handleDelete}
              loading={isLoading}
            >
              {deleteButtonText}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
  );
};

export default DeleteConfirmationModal;
